import axios from "axios";
import { random } from "Util/Strings";

const localStoragePrefix = "_snwaccounts_";
const clientId = process.env.REACT_APP_OAUTH_CLIENT_ID;
const baseUrl = process.env.REACT_APP_OAUTH_SERVER;
const appDomain = process.env.REACT_APP_DOMAIN;

/**
 * Returns user response.
 * Response is not wrapped in a user transformer.
 * @returns {Promise<string>}
 */
export async function getMe() {
    let response;
    try {
        response = await axios.get(
            process.env.REACT_APP_OAUTH_SERVER + "/api/v2/me",
            {
                headers: {
                    Authorization: "Bearer " + getOauthToken(),
                },
            }
        );
    } catch (e) {
        return 401;
    }

    if (!response || response.status !== 200) {
        return 500;
    }

    return response.data;
}

/**
 * Request a new access token.
 * @returns {Promise<string>}
 */
export async function requestAccessToken(exchangeToken, checkState) {
    if (!checkState || checkState !== getOauthCheckState()) {
        console.log(checkState, getOauthCheckState());
        return false;
    }
    const params = {
        client_id: clientId,
        grant_type: "authorization_code",
        redirect_uri: encodeURIComponent(appDomain + "/authorize"),
        code: exchangeToken,
        code_verifier: getOauthChallengeState(),
    };
    let response;

    try {
        response = await axios.post(
            baseUrl + "/auth/v2/access-token",
            new URLSearchParams(params),
            { withCredentials: false }
        );
    } catch (e) {
        console.log(e);
        return false;
    }

    if (!response || response.status !== 200) {
        console.log(response);
        return false;
    }

    setOauthToken(response.data.access_token);
    setOauthRefreshToken(response.data.refresh_token);

    return response.data.access_token;
}

/**
 * Refreshes access token with refresh token
 * @returns {Promise<string>}
 */
export async function requestRefreshToken() {
    let response;
    console.log("Refreshing token...");

    const params = {
        client_id: clientId,
        grant_type: "refresh_token",
        redirect_uri: encodeURIComponent(appDomain + "/authorize"),
        refresh_token: getOauthRefreshToken(),
    };

    try {
        response = await axios.post(
            baseUrl + "/auth/v2/access-token",
            new URLSearchParams(params),
            { withCredentials: false }
        );
    } catch (e) {
        console.log(e);
        return false;
    }

    if (!response || response.status !== 200) {
        console.log(response);
        return false;
    }

    console.log("Token refreshed.");

    setOauthToken(response.data.access_token);
    setOauthRefreshToken(response.data.refresh_token);

    return response.data.access_token;
}

export function getOauthToken() {
    return localStorage.getItem(localStoragePrefix + "token");
}

export function setOauthToken(token) {
    localStorage.setItem(localStoragePrefix + "token", token);
}

export function removeOauthToken() {
    localStorage.removeItem(localStoragePrefix + "token");
}

export function getOauthRefreshToken() {
    return localStorage.getItem(localStoragePrefix + "refreshToken");
}

export function setOauthRefreshToken(token) {
    localStorage.setItem(localStoragePrefix + "refreshToken", token);
}

export function removeOauthRefreshToken() {
    localStorage.removeItem(localStoragePrefix + "refreshToken");
}

export function setNewOauthCheckState() {
    const checkState = random(32);
    localStorage.setItem(localStoragePrefix + "checkState", checkState);
    return checkState;
}
export function getOauthCheckState() {
    return localStorage.getItem(localStoragePrefix + "checkState");
}

export function setNewOauthChallengeState() {
    const challengeState = random(50);
    localStorage.setItem(localStoragePrefix + "challengeState", challengeState);
    return challengeState;
}
export function getOauthChallengeState() {
    return localStorage.getItem(localStoragePrefix + "challengeState");
}

export function getPublicationUuid() {
    return localStorage.getItem(localStoragePrefix + "publicationUuid");
}
export function setPublicationUuid(uuid) {
    localStorage.setItem(localStoragePrefix + "publicationUuid", uuid);
}
export function removePublicationUuid() {
    localStorage.removeItem(localStoragePrefix + "publicationUuid");
}
export function getPublicationCode() {
    return localStorage.getItem(localStoragePrefix + "PublicationCode");
}
export function setPublicationCode(code) {
    localStorage.setItem(localStoragePrefix + "PublicationCode", code);
}
export function removePublicationCode() {
    localStorage.removeItem(localStoragePrefix + "PublicationCode");
}

export function getOauthUrl(continueTo = "/app/dashboard") {
    const newCheckState = setNewOauthCheckState();
    const newChallenge = setNewOauthChallengeState();

    let params = {
        client_id: clientId,
        redirect_uri: encodeURIComponent(appDomain + "/authorize"),
        state: newCheckState,
        code_challenge: newChallenge,
        scope: "",
        response_type: "code",
        approval_prompt: "auto",
        continue: continueTo,
    };

    return baseUrl + "/auth/v2/authorize?" + new URLSearchParams(params);
}
